<partial-header></partial-header> 
<div class="page page-product bg-grey">
  <breadcrumb-list [data]="dataB" *ngIf="dataB != null"></breadcrumb-list>
  <div *ngIf="response.status == 1">
    <div class="page-content">
      <div class="container">
        <div class="page-title">
          <h1>{{produto.nome}}</h1>
        </div> 
        <div class="section-description">
          <div class="row row-main">
              <div class="col-md-8">    
                  <div class="box box-galeria box-sombra-content">
                    <produto-galeria [photos]="fotos" *ngIf="fotos.length > 0"></produto-galeria>
                  </div>
                  <div class="box box-sombra-content box-description-content" *ngFor="let t of textos">
                      <h3 class="title-h3">{{t.titulo}}</h3> 
                      <div class="box box-description" [innerHtml]="t.texto | safeHtml"></div>  
                  </div>      
              </div>
              <div class="col-md-4">
                  <div class="box-sombra content-cart">
                    <dm-cart-add [estoque]="estoque" [inCart]="inCart" [configuracaoLoja]="configuracaoLoja" [produto]="produto"></dm-cart-add>
                    <btn-cart-sem-estoque *ngIf="estoque.quantidade_atual <= 0"></btn-cart-sem-estoque>
                  </div>    
              </div>    
          </div>
          <div class="linha" *ngIf="produtos.length > 0"></div>
          <div class="section-products" *ngIf="produtos.length > 0"> 
            <produto-item-slider-two [produtos]="produtos"></produto-item-slider-two>
          </div>   
      </div>
      <div class="linha"></div>
      </div>
    </div> 
  </div>
  <div *ngIf="response.status == 500">
    <div class="container">  
      <page-error [data]="response.data" (reload)="getData()"></page-error>
    </div>  
  </div>
</div>
<loader [hidden]="!loader"></loader>
<partial-footer></partial-footer>